import React, { useEffect } from 'react';
import { NavLink , useNavigate} from "react-router-dom";
import './navbar.css';




const Navbar = () => {

  const navigate = useNavigate();
  let count = Number(sessionStorage.getItem("uploadCount"))

  // const handleClick =() => {
  //   sessionStorage.setItem("uploadCount", Number(sessionStorage.getItem("uploadCount"))+1)
  // };

  const resetClick = () => {
    sessionStorage.setItem("uploadCount", 0)
  };

  useEffect(() => {
    
    if(Number(sessionStorage.getItem("uploadCount")) === 10){
      navigate("/Login");
      resetClick();
    };
  }, [count, navigate])

  return (
    
      <nav className="navbar">
        <div className="container">

          <NavLink  to="/">
            <div className="logo" >
              <img src={require('./logo.png')} alt="React Logo" />
            </div>
          </NavLink>
          <div className="nav-elements">

           

            <div id="menuToggle">
            
              <input type="checkbox" id="checkBox"/>

              <span></span>
              <span></span>
              <span></span>


              <ul id ="menu">
                  <li> 
                    <NavLink onClick={resetClick} to="/Driver">Driver </NavLink> 
                  </li>
                  <li> 
                    <NavLink onClick={resetClick} to="/BackSeat">Back Seat</NavLink> 
                  </li>
                  <li> 
                    <NavLink onClick={resetClick} to="/Booking">Booking</NavLink> 
                  </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    )
};

export default Navbar;